var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
import * as React from 'react';
import { useSelector } from 'react-redux';
import styled from 'styled-components';
import { useHistory } from 'react-router-dom';
import { Text, Icon, StackChildren, InlineChildren, } from '@doordash/design-language';
import { ChecklistContainer, Cell } from './Checklist';
import { useMediaQuery } from '../../Common/MediaQueryProvider';
import { OnboardingStep, WorkBenefit } from '../../../types/GloblalTypes';
import { ChecklistTestIds } from './testIds';
import ListCell from '@doordash/component-list-cell';
import Button from '@doordash/component-button';
import OnboardingPageStrings from './OnboardingStrings';
import { getSelectedTeamAccount } from '../../../selectors/uiSelector';
import { useSetOnboardingStepMutation } from './useSetOnboardingStepMutation';
import { PORTAL_ROUTE_PREFIX } from '../../../constants/values';
import InfoBanner, { BannerType } from '../../Common/InfoBanner';
var FinishOnboardingViewContainer = styled(StackChildren).attrs(function () { return ({
    size: StackChildren.Sizes.Medium,
}); })(templateObject_1 || (templateObject_1 = __makeTemplateObject([""], [""])));
var FinishOnboardingView = function (_a) {
    var checklistItems = _a.checklistItems, workBenefit = _a.workBenefit;
    var history = useHistory();
    var isMobile = useMediaQuery().isMobile;
    var _b = __read(React.useState(false), 2), isFinishingStep = _b[0], setIsFinishingStep = _b[1];
    var teamAccountId = useSelector(getSelectedTeamAccount);
    var setOnboardingStep = useSetOnboardingStepMutation(teamAccountId, OnboardingStep.ONBOARDING_STEP_FINISH_ONBOARDING, {
        onCompleted: function () {
            setIsFinishingStep(false);
            // only navigate away from the current page when onboarding step is set
            // it allows the sidebar to show the correct list of menu items (without onboarding item)
            history.push(PORTAL_ROUTE_PREFIX + "/admin");
        },
    }).setOnboardingStep;
    var isOnboardingDashPass = workBenefit === WorkBenefit.WORK_BENEFIT_DASHPASS;
    var bannerTitle = isOnboardingDashPass
        ? OnboardingPageStrings.dashPass.finishOnboardingBannerTitle()
        : OnboardingPageStrings.expensedMeals.finishOnboardingBannerTitle();
    var bannerText = isOnboardingDashPass
        ? OnboardingPageStrings.dashPass.finishOnboardingBannerText()
        : OnboardingPageStrings.expensedMeals.finishOnboardingBannerText();
    var setFinishOnboarding = function () {
        setIsFinishingStep(true);
        setOnboardingStep();
    };
    return (React.createElement(FinishOnboardingViewContainer, null,
        React.createElement(ChecklistContainer, { role: "list", isMobile: isMobile }, checklistItems.map(function (listItem, index) {
            var title = listItem.title;
            var textColor = Text.Colors.SystemGrey60;
            return (React.createElement(Cell, { key: listItem.key + "-" + index, "data-testid": ChecklistTestIds["step-" + listItem.key], accessibilityLabel: title, isMobile: isMobile, title: React.createElement(Text, { styles: Text.Styles.Body1Emphasis, color: textColor, "data-testid": ChecklistTestIds.checklistItemTitle }, title), iconStart: {
                    type: Icon.Types.CheckCircleFill,
                    color: Icon.Colors.SystemGrey60,
                }, insetVerticalSize: ListCell.InsetSizes.XSmall }));
        })),
        React.createElement(InfoBanner, { justification: InlineChildren.Justification.FlexStart, bannerType: BannerType.ANNOUNCEMENT, bannerTitle: bannerTitle, bannerText: bannerText }),
        React.createElement(Button, { size: Button.Sizes.Medium, type: Button.Types.Tertiary, state: isFinishingStep ? Button.States.Loading : Button.States.Default, isInline: true, onClick: setFinishOnboarding }, OnboardingPageStrings.finishOnboardingButton())));
};
export default FinishOnboardingView;
var templateObject_1;
